import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {L10nModule} from '../translate';
import {SwitchComponent} from './switch.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        L10nModule
    ],
    declarations: [
        SwitchComponent
    ],
    exports: [
        SwitchComponent
    ]
})
export class SwitchModule {}
